export default {
  menu: 'Menu',
  wineList: 'Wine list',
  locale: 'Select your language<br/> to access the menu:',
  claim:
    'From the terrace,<br/> every dish tells a story,<br/> every glance discovers the horizon.',
  claimWine: 'A terrace on history,<br /> a toast to the land.',
  appetizer: 'Cold cuts, cheeses and more',
  'hot-dishes': 'Hot dishes',
  'fish-dishes': 'Flavors of the sea',
  dessert: 'Sweet endings',
  drinks: 'To drink and to taste',
  cocktail: 'Alchemy in a glass',
  coffee: 'Coffee moment',
  spirits: 'Distilled essence',
  beer: 'Malt and hops in celebration',
  bollicine: 'Valdobbiadene DOCG & CO',
  altreBollicine: 'Other local sparkling wines',
  champagne: 'Classic method and Champagne',
  viniBianchi: 'White wines',
  viniRossi: 'Red wines',
  glass: 'Glass',
  bottle: 'Bottle',
  takeAway: 'Take away',
  social: 'Follow us on',
  service: 'Cover charge €2',
  info: 'For information on allergens and intolerances, please ask the staff.<br/> Some products may be frozen.',
  time: 'Opening hours',
  contacts: 'Contacts',
  directions: 'Directions',
  monday: 'Monday',
  tuesday: 'Tuesday',
  wednesday: 'Wednesday',
  thursday: 'Thursday',
  friday: 'Friday',
  saturday: 'Saturday',
  sunday: 'Sunday',
  close: 'Chiuso',
  contact: 'Contacts',
}
